import React from "react";
import { useFormik } from "formik";
import Grid from "@material-ui/core/Grid";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

// Custom styles with mobile responsiveness
const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    overflowX: "hidden", // Prevent horizontal scrollbar
    width: "100%",
    maxWidth: "600px", // Constrain max width to avoid overflow
    margin: "0 auto", // Center the dialog content
    boxSizing: "border-box",
  },
  dialogTitle: {
    fontFamily: "Roboto, sans-serif",
    fontWeight: 800,
    fontSize: "14px",
    color: "#1A3C5E",
    textAlign: "center",
    padding: "36px 24px 34px 24px", // Increased top padding to 26px, bottom to 34px (+10px)
    marginTop: "0px", // Remove extra top margin
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: "28px 16px 26px 16px", // Increased top padding to 18px, bottom to 26px (+10px)
    },
  },
  dialogContentTop: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "14px",
    color: "#1A3C5E",
    textAlign: "center",
    padding: "0 24px 10px", // Fixed padding
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: "0 16px 8px",
    },
  },
  dialogContent: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "14px",
    color: "#1A3C5E",
    textAlign: "center",
    padding: "0 24px", // Consistent padding
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      padding: "0 16px",
    },
  },
  bulletText: {
    marginTop: "8px",
    marginBottom: "8px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "4px",
      marginBottom: "4px",
    },
  },
  closeButton: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "14px",
    color: "#62B3E1",
    borderColor: "#62B3E1",
    textTransform: "none",
    width: "200px",
    borderRadius: "8px",
    padding: "8px 24px", // Fixed padding
    [theme.breakpoints.down("sm")]: {
      width: "150px",
      fontSize: "12px",
      padding: "8px 16px",
    },
  },
  dialogActions: {
    padding: "0 24px 26px", // Bottom padding from previous update
    display: "flex",
    justifyContent: "center", // Center the button
    [theme.breakpoints.down("sm")]: {
      padding: "0 16px 18px", // Bottom padding from previous update
    },
  },
  buttonContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "16px", // Fixed margin
    marginBottom: "0px", // Remove extra bottom margin
  },
}));

const WeatherGuideDialog = ({ handleClose }) => {
  const classes = useStyles();

  return (
    <Box className={classes.dialogContainer}>
      <DialogTitle className={classes.dialogTitle}>
        Why Weather Matters
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Grid direction="column" container>
          <Grid item>
            <Typography className={classes.dialogContentTop}>
              Outdoor weather conditions— temperature, humidity, wind, and air pressure—can influence how radon enters and moves through your home. Comparing radon levels with weather trends can help you identify patterns or unusual changes.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Grid
          container
          direction="row"
          alignItems="center"
          spacing={2}
          className={classes.buttonContainer}
        >
          <Grid item>
            <Button
              variant="outlined"
              className={classes.closeButton}
              onClick={handleClose}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Box>
  );
};

export default WeatherGuideDialog;
